import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  container: {
    flexGrow: 1,
  },
  containerModern: {
    flex: "1 1 auto",
    minHeight: 0,
    // padding: "0 6px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
});

class DimensionsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      painted: false,
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ painted: true }), 50);
  }

  render() {
    const { classes, variant = "default", children } = this.props;
    const isModern = variant === "modern";

    return (
      <div
        className={classNames(classes.container, {
          [classes.containerModern]: isModern,
        })}
        ref={this.containerRef}
      >
        {this.state.painted &&
          this.containerRef !== null &&
          this.containerRef.current &&
          React.cloneElement(children, {
            height: this.containerRef.current.offsetHeight,
            width: this.containerRef.current.offsetWidth,
            variant,
          })}
      </div>
    );
  }
}

DimensionsContainer.defaultProps = {
  variant: "default",
};

export default withStyles(styles)(DimensionsContainer);
